export default {
      id: "ic-fil-author-comments-light-grey-usage",
      viewBox: "0 0 21 20",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-author-comments-light-grey-usage",
      toString: function () {
        return this.url;
      }
    }